/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import { EmissionsIntensityMeasures } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function EmissionsIntensityMeasuresCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    EmissionsIntensityName: "",
    EmissionsIntensityUnit: "",
    EmissionsIntensityValue: "",
    YearMeasured: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [EmissionsIntensityName, setEmissionsIntensityName] = React.useState(
    initialValues.EmissionsIntensityName
  );
  const [EmissionsIntensityUnit, setEmissionsIntensityUnit] = React.useState(
    initialValues.EmissionsIntensityUnit
  );
  const [EmissionsIntensityValue, setEmissionsIntensityValue] = React.useState(
    initialValues.EmissionsIntensityValue
  );
  const [YearMeasured, setYearMeasured] = React.useState(
    initialValues.YearMeasured
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setEmissionsIntensityName(initialValues.EmissionsIntensityName);
    setEmissionsIntensityUnit(initialValues.EmissionsIntensityUnit);
    setEmissionsIntensityValue(initialValues.EmissionsIntensityValue);
    setYearMeasured(initialValues.YearMeasured);
    setErrors({});
  };
  const validations = {
    EmissionsIntensityName: [],
    EmissionsIntensityUnit: [],
    EmissionsIntensityValue: [],
    YearMeasured: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          EmissionsIntensityName,
          EmissionsIntensityUnit,
          EmissionsIntensityValue,
          YearMeasured,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new EmissionsIntensityMeasures(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "EmissionsIntensityMeasuresCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Greenhouse Gas Emissions Intensity Metric"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 22d."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Create a record describing a GHG emissions intensity metric."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Emissions intensity metric name"
        isRequired={false}
        isReadOnly={false}
        value={EmissionsIntensityName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              EmissionsIntensityName: value,
              EmissionsIntensityUnit,
              EmissionsIntensityValue,
              YearMeasured,
            };
            const result = onChange(modelFields);
            value = result?.EmissionsIntensityName ?? value;
          }
          if (errors.EmissionsIntensityName?.hasError) {
            runValidationTasks("EmissionsIntensityName", value);
          }
          setEmissionsIntensityName(value);
        }}
        onBlur={() =>
          runValidationTasks("EmissionsIntensityName", EmissionsIntensityName)
        }
        errorMessage={errors.EmissionsIntensityName?.errorMessage}
        hasError={errors.EmissionsIntensityName?.hasError}
        {...getOverrideProps(overrides, "EmissionsIntensityName")}
      ></TextField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid5")}
      >
        <TextField
          label="Unit to measure emissions intensity (e.g. kg CO2e per $revenue)"
          isRequired={false}
          isReadOnly={false}
          value={EmissionsIntensityUnit}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionsIntensityName,
                EmissionsIntensityUnit: value,
                EmissionsIntensityValue,
                YearMeasured,
              };
              const result = onChange(modelFields);
              value = result?.EmissionsIntensityUnit ?? value;
            }
            if (errors.EmissionsIntensityUnit?.hasError) {
              runValidationTasks("EmissionsIntensityUnit", value);
            }
            setEmissionsIntensityUnit(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionsIntensityUnit", EmissionsIntensityUnit)
          }
          errorMessage={errors.EmissionsIntensityUnit?.errorMessage}
          hasError={errors.EmissionsIntensityUnit?.hasError}
          {...getOverrideProps(overrides, "EmissionsIntensityUnit")}
        ></TextField>
        <TextField
          label="Emissions intensity value"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EmissionsIntensityValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                EmissionsIntensityName,
                EmissionsIntensityUnit,
                EmissionsIntensityValue: value,
                YearMeasured,
              };
              const result = onChange(modelFields);
              value = result?.EmissionsIntensityValue ?? value;
            }
            if (errors.EmissionsIntensityValue?.hasError) {
              runValidationTasks("EmissionsIntensityValue", value);
            }
            setEmissionsIntensityValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "EmissionsIntensityValue",
              EmissionsIntensityValue
            )
          }
          errorMessage={errors.EmissionsIntensityValue?.errorMessage}
          hasError={errors.EmissionsIntensityValue?.hasError}
          {...getOverrideProps(overrides, "EmissionsIntensityValue")}
        ></TextField>
      </Grid>
      <TextField
        label="Year measured"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={YearMeasured}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              EmissionsIntensityName,
              EmissionsIntensityUnit,
              EmissionsIntensityValue,
              YearMeasured: value,
            };
            const result = onChange(modelFields);
            value = result?.YearMeasured ?? value;
          }
          if (errors.YearMeasured?.hasError) {
            runValidationTasks("YearMeasured", value);
          }
          setYearMeasured(value);
        }}
        onBlur={() => runValidationTasks("YearMeasured", YearMeasured)}
        errorMessage={errors.YearMeasured?.errorMessage}
        hasError={errors.YearMeasured?.hasError}
        {...getOverrideProps(overrides, "YearMeasured")}
      ></TextField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
